import { action } from 'satcheljs';
import { MiniWorkLoad } from 'mini-workload';

/**
 * Action to toggle visibility of report error form
 * @param source The app from which this action is triggered
 * @param show Whether to show or hide the report error form
 */
const showHideReportErrorForm = action(
    'showHideReportErrorForm',
    (source: MiniWorkLoad, show: boolean) => ({
        source,
        show,
    })
);

export default showHideReportErrorForm;
